<div class="forgot-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
            >
                <div class="title text-center">
                    <h3>
                        Forgot Your Password?
                    </h3>
                    <p class="ml-auto mr-auto">
                        Enter the E-mail you used when you joined and we’ll send you instructions to reset your password.
                    </p>
                </div>
<form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label class="main-label d-block lh-1 text-black">E-mail</label>
    <mat-form-field appearance="fill">
      <mat-label>Enter E-mail</mat-label>
      <input matInput type="email" formControlName="email" />
    </mat-form-field>
  </div>

  <button mat-button class="btn" type="submit" [disabled]="forgotPasswordForm.invalid">Send</button>

  <div *ngIf="message" class="success-message">{{ message }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <div class="text-center back-to-sign-in">
    <a mat-button routerLink="/authentication">
      <i class="ri-arrow-left-s-line"></i> Retour pour se connecter
    </a>
  </div>
</form>

            </div>
        </div>
    </div>
</div>